import React, { FC } from "react";
import _ from "lodash";
import theme from "styles/theme";
import ColorPreview from "./color-preview";
import { IItemRecord } from "records/item/item";
import { makeStyles, Theme } from "@material-ui/core/styles";
import type { IScope } from "reducers/scope";
import { format } from "lib/globalize-util";
import VariantsProvider from "components/variants-provider";

interface IProps {
    item: IItemRecord;
    scope: IScope;
    small?: boolean;
    maxChipsAmount?: number;
    chipsCountOnSlide?: number;
    isGrapesJs?: boolean;
    onSwatchSelected(e: Event, swatch: { _id: string; name: string }): void;
    onToggleViewMore(open: boolean): void;
}

export const MoreColors: FC<IProps> = (props) => {
    const { item, small, scope, onToggleViewMore, onSwatchSelected, maxChipsAmount, chipsCountOnSlide, isGrapesJs } =
        props;
    const inner = useStyles({ small });
    return (
        <VariantsProvider item={item}>
            {({ variants, isFetching }) =>
                scope?.brand?.modules?.base?.color_swatches?.length && !isFetching && !_.isEmpty(variants) ? (
                    <ColorPreview
                        activeBrand={scope?.brand}
                        item={item}
                        variants={variants}
                        small={small}
                        maxChipsAmount={maxChipsAmount}
                        chipsCountOnSlide={chipsCountOnSlide}
                        isGrapesJs={isGrapesJs}
                        onSwatchSelected={onSwatchSelected}
                        onToggleViewMore={onToggleViewMore}
                    />
                ) : (
                    <div className={inner.indicator}>{format("more colors")}</div>
                )
            }
        </VariantsProvider>
    );
};

const useStyles = makeStyles<Theme, { small?: boolean }>({
    indicator: ({ small }) => ({
        position: "absolute",
        zIndex: 2,
        color: theme.palette.accent1Color,
        bottom: 4,
        fontSize: small ? 12 : 14,
    }),
});

export default MoreColors;
